import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { Provider } from '@kr/models';
import { DictionariesStore } from '@kr/store';

@Component({
  selector: 'kr-provider-icon',
  template: `
    @if (provider) {
      <div class="provider-icon" [ngStyle]="iconStyle">
        {{ provider.icon_letter }}
      </div>
    }
  `,
  styleUrls: ['./provider-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle],
})
export class ProviderIconComponent {
  readonly #dictionariesStore = inject(DictionariesStore);
  readonly #providers = this.#dictionariesStore.allProviders;

  providerType = input.required<string>();
  size = input<'small' | 'large'>('small');

  get provider(): Provider | null {
    const providerList = this.#providers();
    return providerList?.length ? providerList.find(provider => provider.type?.toLowerCase() === this.providerType()?.toLowerCase()) : null;
  }

  get iconSize(): { numberSize: string; fontSize: string } {
    return this.size() === 'small' ? { numberSize: '20', fontSize: '14' } : { numberSize: '24', fontSize: '16' };
  }

  get iconStyle() {
    const { numberSize, fontSize } = this.iconSize;
    return {
      'width.px': numberSize,
      'height.px': numberSize,
      'font-size.px': fontSize,
      'background-color': this.provider?.icon_background_color,
      color: this.provider?.icon_color_of_letter,
    };
  }
}
